module.exports = __webpack_public_path__ + "static/media/jump.6191f22d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/story/sounds/jump.mp3
// module id = 86
// module chunks = 0